import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { AnnualIncome, EmploymentStatus, FormType, PreferredContactTime, PreferredCorrespondence } from '../types';
import { DatePicker, Radio, Select, TextArea, TextFiled } from 'tsx/comps/form';
import { get, set } from 'lodash';
import { countries } from '../data';

const Div = styled.div``;

interface Step3Props {
  onNext: () => void;
  onPrev: () => void;
}

export const Step3: React.FC<Step3Props> = ({ onNext, onPrev }) => {
  const { values, handleChange, handleBlur, touched, errors, setFieldValue, setFieldTouched, validateField } =
    useFormikContext<FormType>();

  // console.log('ERRORS: ', errors.secondAccountHolderPersonalDetails);

  const validate = () => {
    const timer = setTimeout(() => {
      validateField('secondAccountHolderPersonalDetails');
      clearTimeout(timer);
    }, 1);
  };

  return (
    <Div>
      <h2>Personal Details (2nd Account Holder)</h2>
      <div className="spc30" />
      <span className="label">Are you an existing customer of Chorley Building Society?</span>
      <div className="radio-container">
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.existingCustomer}
            onChange={() => setFieldValue('secondAccountHolderPersonalDetails.existingCustomer', true)}
          />
          <p className="radio-container__item__label">Yes</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={!values.secondAccountHolderPersonalDetails.existingCustomer}
            onChange={() => setFieldValue('secondAccountHolderPersonalDetails.existingCustomer', false)}
          />
          <p className="radio-container__item__label">No</p>
        </div>
      </div>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Title</span>
          <Select
            id="secondAccountHolderPersonalDetails.title.value"
            // value={values.secondAccountHolderPersonalDetails.title.value}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.title.value') &&
                get(errors, 'secondAccountHolderPersonalDetails.title.value'),
            )}
            $hasValue={!!get(values, 'secondAccountHolderPersonalDetails.title.value')}
          >
            <option value="" disabled selected>
              Select
            </option>
            <option value="Mr">Mr</option>
            <option value="Ms">Ms</option>
            <option value="Mrs">Mrs</option>
            <option value="Miss">Miss</option>
            {/* <option value="Other">Other</option> */}
          </Select>
        </div>
      </div>
      {/* {values.secondAccountHolderPersonalDetails.title.value === 'Other' && (
        <>
          <div className="spc10" />
          <div className="input-grid">
            <TextFiled
              id="secondAccountHolderPersonalDetails.title.otherValue"
              $fullWidth
              value={values.secondAccountHolderPersonalDetails.title.otherValue}
              onBlur={handleBlur}
              onChange={handleChange}
              error={Boolean(
                get(touched, 'secondAccountHolderPersonalDetails.title.otherValue') &&
                  get(errors, 'secondAccountHolderPersonalDetails.title.otherValue'),
              )}
            />
          </div>
        </>
      )} */}
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Forename(s)</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.firstName"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.firstName}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.firstName') &&
                get(errors, 'secondAccountHolderPersonalDetails.firstName'),
            )}
          />
        </div>
        <div>
          <span className="label">Surname</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.lastName"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.lastName}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.lastName') &&
                get(errors, 'secondAccountHolderPersonalDetails.lastName'),
            )}
          />
        </div>
      </div>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Telephone Number</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.contactNumber"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.contactNumber}
            onBlur={handleBlur}
            onChange={handleChange}
            // type="number"
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.contactNumber') &&
                get(errors, 'secondAccountHolderPersonalDetails.contactNumber'),
            )}
          />
        </div>
        <div>
          <span className="label">Alternative Number</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.alternativeContactNumber"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.alternativeContactNumber}
            onBlur={handleBlur}
            onChange={handleChange}
            // type="number"
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.alternativeContactNumber') &&
                get(errors, 'secondAccountHolderPersonalDetails.alternativeContactNumber'),
            )}
          />
        </div>
      </div>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Email Address</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.emailAddress"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.emailAddress}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.emailAddress') &&
                get(errors, 'secondAccountHolderPersonalDetails.emailAddress'),
            )}
          />
        </div>
        <div>
          <span className="label">Nationality</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.nationality"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.nationality}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.nationality') &&
                get(errors, 'secondAccountHolderPersonalDetails.nationality'),
            )}
          />
        </div>
      </div>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Country of Birth</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.countryOfBirth"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.countryOfBirth}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.countryOfBirth') &&
                get(errors, 'secondAccountHolderPersonalDetails.countryOfBirth'),
            )}
          />
        </div>
        <div>
          <span className="label">Date of Birth</span>
          <DatePicker
            placeholderText="DD/MM/YYYY"
            dateFormat="dd/MM/yyy"
            id="secondAccountHolderPersonalDetails.dateOfBirth"
            selected={
              values.secondAccountHolderPersonalDetails.dateOfBirth
                ? new Date(values.secondAccountHolderPersonalDetails.dateOfBirth)
                : null
            }
            onChange={(date) => setFieldValue('secondAccountHolderPersonalDetails.dateOfBirth', date?.toISOString())}
            onBlur={handleBlur}
            // @ts-ignore
            $fullWidth
            showPopperArrow={false}
            showYearDropdown
            dropdownMode="select"
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.dateOfBirth') &&
                get(errors, 'secondAccountHolderPersonalDetails.dateOfBirth'),
            )}
          />
        </div>
      </div>
      <div className="spc30" />
      <span className="label">Current Address</span>
      <div className="spc10" />
      <TextFiled
        id="secondAccountHolderPersonalDetails.currentAddress.line1"
        placeholder="Address line 1"
        $fullWidth
        value={values.secondAccountHolderPersonalDetails.currentAddress.line1}
        onBlur={handleBlur}
        onChange={handleChange}
        error={Boolean(
          get(touched, 'secondAccountHolderPersonalDetails.currentAddress.line1') &&
            get(errors, 'secondAccountHolderPersonalDetails.currentAddress.line1'),
        )}
      />
      <div className="spc10" />
      <div className="spc10" />
      <TextFiled
        id="secondAccountHolderPersonalDetails.currentAddress.line2"
        placeholder="Address line 2"
        $fullWidth
        value={values.secondAccountHolderPersonalDetails.currentAddress.line2}
        onBlur={handleBlur}
        onChange={handleChange}
        error={Boolean(
          get(touched, 'secondAccountHolderPersonalDetails.currentAddress.line2') &&
            get(errors, 'secondAccountHolderPersonalDetails.currentAddress.line2'),
        )}
      />
      <div className="spc10" />
      <div className="spc10" />
      <div className="input-grid">
        <TextFiled
          id="secondAccountHolderPersonalDetails.currentAddress.city"
          placeholder="City"
          $fullWidth
          value={values.secondAccountHolderPersonalDetails.currentAddress.city}
          onBlur={handleBlur}
          onChange={handleChange}
          error={Boolean(
            get(touched, 'secondAccountHolderPersonalDetails.currentAddress.city') &&
              get(errors, 'secondAccountHolderPersonalDetails.currentAddress.city'),
          )}
        />
        <TextFiled
          id="secondAccountHolderPersonalDetails.currentAddress.county"
          placeholder="County"
          $fullWidth
          value={values.secondAccountHolderPersonalDetails.currentAddress.county}
          onBlur={handleBlur}
          onChange={handleChange}
          error={Boolean(
            get(touched, 'secondAccountHolderPersonalDetails.currentAddress.county') &&
              get(errors, 'secondAccountHolderPersonalDetails.currentAddress.county'),
          )}
        />
      </div>
      <div className="spc10" />
      <div className="spc10" />
      <div className="input-grid">
        <TextFiled
          id="secondAccountHolderPersonalDetails.currentAddress.postcode"
          placeholder="Postcode"
          $fullWidth
          value={values.secondAccountHolderPersonalDetails.currentAddress.postcode}
          onBlur={handleBlur}
          onChange={handleChange}
          error={Boolean(
            get(touched, 'secondAccountHolderPersonalDetails.currentAddress.postcode') &&
              get(errors, 'secondAccountHolderPersonalDetails.currentAddress.postcode'),
          )}
        />
        <Select
          id="secondAccountHolderPersonalDetails.currentAddress.country"
          value={values.secondAccountHolderPersonalDetails.currentAddress.country}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            get(touched, 'secondAccountHolderPersonalDetails.currentAddress.country') &&
              get(errors, 'secondAccountHolderPersonalDetails.currentAddress.country'),
          )}
          $hasValue={!!get(values, 'secondAccountHolderPersonalDetails.currentAddress.country')}
        >
          <option value="" disabled selected>
            Country
          </option>
          {countries.map((el) => (
            <option key={el.name} value={el.name}>
              {el.name}
            </option>
          ))}
        </Select>
      </div>
      <div className="spc30" />
      <span className="label">Preferred Correspondence</span>
      <div className="spc10" />
      <div className="radio-container">
        <div className="radio-container__item">
          <Radio
            checked={
              values.secondAccountHolderPersonalDetails.preferredCorrespondence === PreferredCorrespondence.EMAIL
            }
            onChange={() =>
              setFieldValue('secondAccountHolderPersonalDetails.preferredCorrespondence', PreferredCorrespondence.EMAIL)
            }
          />
          <p className="radio-container__item__label">Email</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.preferredCorrespondence === PreferredCorrespondence.POST}
            onChange={() =>
              setFieldValue('secondAccountHolderPersonalDetails.preferredCorrespondence', PreferredCorrespondence.POST)
            }
          />
          <p className="radio-container__item__label">Post</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={
              values.secondAccountHolderPersonalDetails.preferredCorrespondence === PreferredCorrespondence.PHONE
            }
            onChange={() =>
              setFieldValue('secondAccountHolderPersonalDetails.preferredCorrespondence', PreferredCorrespondence.PHONE)
            }
          />
          <p className="radio-container__item__label">Phone</p>
        </div>
      </div>
      <div className="spc30" />
      <span className="label">Preferred Contact Time</span>
      <div className="spc10" />
      <div className="radio-container">
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.preferredContactTime === PreferredContactTime.AM}
            onChange={() =>
              setFieldValue('secondAccountHolderPersonalDetails.preferredContactTime', PreferredContactTime.AM)
            }
          />
          <p className="radio-container__item__label">AM</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.preferredContactTime === PreferredContactTime.PM}
            onChange={() =>
              setFieldValue('secondAccountHolderPersonalDetails.preferredContactTime', PreferredContactTime.PM)
            }
          />
          <p className="radio-container__item__label">PM</p>
        </div>
      </div>
      <div className="spc30" />
      <div className="spc30" />
      <h5>Tax Liabilities</h5>
      <div className="spc30" />
      <span className="label">Are you a US citizen?</span>
      <div className="spc10" />
      <div className="radio-container">
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.usCitizen.value === true}
            onChange={() => {
              setFieldValue('secondAccountHolderPersonalDetails.usCitizen.value', true);
              validate();
            }}
          />
          <p className="radio-container__item__label">Yes</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.usCitizen.value === false}
            onChange={() => {
              setFieldValue('secondAccountHolderPersonalDetails.usCitizen.value', false);
              setFieldValue('secondAccountHolderPersonalDetails.usCitizen.usTaxIdentificationNumber', '');
              setFieldTouched('secondAccountHolderPersonalDetails.usCitizen', undefined);
              validate();
            }}
          />
          <p className="radio-container__item__label">No</p>
        </div>
      </div>
      {values.secondAccountHolderPersonalDetails.usCitizen.value && (
        <>
          <div className="spc30" />
          <span className="label">Please provide your US Tax Identification No. (TIN)</span>
          <div className="spc10" />
          <div className="input-grid">
            <TextFiled
              id="secondAccountHolderPersonalDetails.usCitizen.usTaxIdentificationNumber"
              $fullWidth
              value={values.secondAccountHolderPersonalDetails.usCitizen.usTaxIdentificationNumber}
              onBlur={handleBlur}
              onChange={handleChange}
              error={Boolean(
                get(touched, 'secondAccountHolderPersonalDetails.usCitizen.usTaxIdentificationNumber') &&
                  get(errors, 'secondAccountHolderPersonalDetails.usCitizen.usTaxIdentificationNumber'),
              )}
            />
          </div>
        </>
      )}
      <div className="spc30" />
      <span className="label">Are you resident for tax purposes anywhere other than the UK?</span>
      <div className="spc10" />
      <div className="radio-container">
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.taxOtherUK.value === true}
            onChange={() => setFieldValue('secondAccountHolderPersonalDetails.taxOtherUK.value', true)}
          />
          <p className="radio-container__item__label">Yes</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.taxOtherUK.value === false}
            onChange={() => {
              setFieldValue('secondAccountHolderPersonalDetails.taxOtherUK.value', false);
              setFieldValue('secondAccountHolderPersonalDetails.taxOtherUK.details', '');
              setFieldTouched('secondAccountHolderPersonalDetails.taxOtherUK', undefined);
              validate();
            }}
          />
          <p className="radio-container__item__label">No</p>
        </div>
      </div>
      {values.secondAccountHolderPersonalDetails.taxOtherUK.value && (
        <>
          <div className="spc30" />
          <span className="label">
            Please list all the countries of which you are tax resident and provide your relevant tax reference or
            Taxpayer Identification No. (or functional equivalent)
          </span>
          <div className="spc10" />
          <TextArea
            id="secondAccountHolderPersonalDetails.taxOtherUK.details"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.taxOtherUK.details}
            rows={5}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.taxOtherUK.details') &&
                get(errors, 'secondAccountHolderPersonalDetails.taxOtherUK.details'),
            )}
          />
        </>
      )}
      <div className="spc30" />
      <div className="spc30" />
      <h5>Employment Status</h5>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Employment Status</span>
          <Select
            id="secondAccountHolderPersonalDetails.employmentStatus.employmentStatus"
            value={values.secondAccountHolderPersonalDetails.employmentStatus.employmentStatus}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.employmentStatus.employmentStatus') &&
                get(errors, 'secondAccountHolderPersonalDetails.employmentStatus.employmentStatus'),
            )}
            $hasValue={!!get(values, 'secondAccountHolderPersonalDetails.employmentStatus.employmentStatus')}
          >
            <option value="" disabled selected>
              Select
            </option>
            {Object.entries(EmploymentStatus).map(([key, value]) => (
              <option key={key} value={value}>
                {key}
              </option>
            ))}
          </Select>
        </div>
        <div>
          <span className="label">Occupation</span>
          <TextFiled
            id="secondAccountHolderPersonalDetails.employmentStatus.occupation"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.employmentStatus.occupation}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.employmentStatus.occupation') &&
                get(errors, 'secondAccountHolderPersonalDetails.employmentStatus.occupation'),
            )}
          />
        </div>
      </div>
      <div className="spc30" />
      <div className="input-grid">
        <div>
          <span className="label">Annual Income</span>
          <Select
            id="secondAccountHolderPersonalDetails.employmentStatus.annualIncome"
            value={values.secondAccountHolderPersonalDetails.employmentStatus.annualIncome}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.employmentStatus.annualIncome') &&
                get(errors, 'secondAccountHolderPersonalDetails.employmentStatus.annualIncome'),
            )}
            $hasValue={!!get(values, 'secondAccountHolderPersonalDetails.employmentStatus.annualIncome')}
          >
            <option value="" disabled selected>
              Select
            </option>
            {Object.entries(AnnualIncome).map(([key, value]) => (
              <option key={key} value={value}>
                {key}
              </option>
            ))}
          </Select>
        </div>
      </div>
      <div className="spc30" />
      <span className="label">
        Do you currently, or have you ever, held a senior position of public trust in the UK or elsewhere (i.e. as a
        politician, councillor or judge whether full or part time, paid or unpaid) or are/were you closely connected to
        anyone that does or did hold one of these positions?
      </span>
      <div className="spc10" />
      <div className="radio-container">
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.value === true}
            onChange={() =>
              setFieldValue('secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.value', true)
            }
          />
          <p className="radio-container__item__label">Yes</p>
        </div>
        <div className="radio-container__item">
          <Radio
            checked={values.secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.value === false}
            onChange={() => {
              setFieldValue('secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.value', false);
              setFieldValue('secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.details', '');
              setFieldTouched('secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails', undefined);
              validate();
            }}
          />
          <p className="radio-container__item__label">No</p>
        </div>
      </div>
      {values.secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.value && (
        <>
          <div className="spc10" />
          <div className="spc10" />
          <p>Please provide further details </p>
          <div className="spc10" />
          <TextArea
            id="secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.details"
            $fullWidth
            value={values.secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.details}
            rows={5}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(
              get(touched, 'secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.details') &&
                get(errors, 'secondAccountHolderPersonalDetails.employmentStatus.seniorPositionDetails.details'),
            )}
          />
        </>
      )}
      <div className="spc30" />
      <div className="spc10" />
      <div className="buttons">
        <button className="btn btn--secondary" onClick={onPrev}>
          Previous
        </button>
        <button className="btn" onClick={onNext} disabled={!!errors.secondAccountHolderPersonalDetails}>
          Next
        </button>
      </div>
    </Div>
  );
};
